/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function ($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function () {

        function cgf_int_get_random_int(min, max) {
          min = Math.ceil(min);
          max = Math.floor(max);
          return Math.floor(Math.random() * (max - min) + min); //The maximum is exclusive and the minimum is inclusive
        }

        jQuery('#mic-verify').each( function() {
          var verify_wrap = jQuery(this);
          verify_wrap.empty();
          var verify_html = '';
          var enc_num     = cgf_int_get_random_int(1,9999);
          var key_num     = cgf_int_get_random_int(1,24);
          var home_url    = verify_wrap.attr('data-hu');
          var theme_url   = verify_wrap.attr('data-td');

          verify_html += '<div class="mic-verify-w mic-left">';
          verify_html += '<input type="hidden" name="enc_num" value="'+enc_num+'">';
          verify_html += '<input type="hidden" name="key_num" value="'+key_num+'">';
          verify_html += '<a class="refresh" id="verify-refresh-captcha" href=""><img src="'+theme_url+'/moove/dist/images/mic-refresh.png" alt="Refresh"></a>';
          verify_html += '<img id="verify_image" src="' + home_url + 'wp-json/mic/v1/cpid?enn=' + enc_num + '&ken=' + key_num + '" alt="Verification code" width="100" />';
          verify_html += '</div>';
          verify_html += '<div class="mic-verify-w mic-right">'
          verify_html += '<input type="text" name="mic_verify" required id="mic_verify" class="text"  placeholder="Enter the captcha" title="This confirms you are a human user and not a bot."/>';
          verify_html += '</div>';
          verify_wrap.html(verify_html);
        });

        jQuery(document).on('click','#verify-refresh-captcha', function(e){
          e.preventDefault();
          var verify_wrap = jQuery(this).closest('#mic-verify');
          verify_wrap.empty();
          var verify_html = '';
          var enc_num     = cgf_int_get_random_int(1,9999);
          var key_num     = cgf_int_get_random_int(1,24);
          var home_url    = verify_wrap.attr('data-hu');
          var theme_url   = verify_wrap.attr('data-td');

          verify_html += '<div class="mic-verify-w mic-left">';
          verify_html += '<input type="hidden" name="enc_num" value="'+enc_num+'">';
          verify_html += '<input type="hidden" name="key_num" value="'+key_num+'">';
          verify_html += '<a class="refresh" id="verify-refresh-captcha" href=""><img src="'+theme_url+'/moove/dist/images/mic-refresh.png" alt="Refresh"></a>';
          verify_html += '<img id="verify_image" src="' + home_url + 'wp-json/mic/v1/cpid?enn=' + enc_num + '&ken=' + key_num + '" alt="Verification code" width="100" />';
          verify_html += '</div>';
          verify_html += '<div class="mic-verify-w mic-right">'
          verify_html += '<input type="text" name="mic_verify" required id="mic_verify" class="text"  placeholder="Enter the captcha" title="This confirms you are a human user and not a bot."/>';
          verify_html += '</div>';
          verify_wrap.html(verify_html);
        });

        $(document).on('change', '#members-aa-profile-info input[type=checkbox]', function(){
          var value = $(this).val();
          var log_action = 'add';
          var ajax_url = $(this).closest('#members-aa-profile-info').find('input[name=aa_ajax_url]').val();
          var user_id = $(this).closest('#members-aa-profile-info').find('input[name=aa_user_id]').val();
          var nonce = $(this).closest('#members-aa-profile-info').find('input[name=cgf_aa_nonce]').val();
 
          if ( ! $(this).is(':checked') ) {
            log_action = 'remove';
          }
          $('#acceleration-areas-latest .loading').show();
          $('.member-related-type-content .loading').show();
  
          $.post(
            ajax_url,
            {
              action:   "cgf_update_user_aa",
              user_id: user_id,
              nonce:    nonce,
              log_action: log_action,
              value: value,
            },
            function( msg ) {
              var obj = JSON.parse( msg );
              var url = $('#acceleration-areas-latest').attr('data-url');
              $('#acceleration-areas-latest .aa-main').html(obj.content);
              $('.member-related-type-content .widget-row').html(obj.widgets);
              $('.member-related-type-content .loading').hide();
            }
          );

        });

        /* ******* RESPONSIVE IFRAME ******** */
        function adjust_iframes() {
          $('body').find('.generic-popup iframe').each(function () {
            var ifWidth = $(this).attr('width');
            var ifHeight = $(this).attr('height');
            var ratio = ifHeight / ifWidth;
            var realWidth = $(this).width();
            var realHeight = realWidth * ratio;
            $(this).css('height', realHeight);
          });
        }

        if (window.location.hash) {
          var hash = window.location.hash.substring(1); //Puts hash in variable, and removes the # character
          if ($('#' + hash).length > 0) {
            if ( $('#' + hash).closest('.cgf-contact-block').length > 0 ) {
              $('#' + hash).addClass('highlighted');
            }
            $('html, body').animate({
              scrollTop: $('#' + hash).offset().top - 100,
            }, 500);
          }
        }

        $(document).on('click','.cgf-contact-block .cgf-cb-link', function(e){
          e.preventDefault();
          var href = $(this).attr('data-href');
          if ( href ) {
            href = href.replace('[cgdc]', '.com');
            href = href.replace('[cgd]', '.');
            href = href.replace('[cga]', '@');
            location.href = "mailto:" + href;
          }
        });

        $(document).on('click','.cgf-hashed-link', function(e){
          e.preventDefault();
          var href = $(this).attr('data-href');
          if ( href ) {
            href = href.replace('[cgdc]', '.com');
            href = href.replace('[cgd]', '.');
            href = href.replace('[cga]', '@');
            location.href = "mailto:" + href;
          }
        });

        $(document).on('click','a[href*="[cga]"]', function(e){
          e.preventDefault();
          var href = $(this).attr('href');
          if ( href ) {
            href = href.replace('mailto:', '');
            href = href.replace('[cgdc]', '.com');
            href = href.replace('[cgd]', '.');
            href = href.replace('[cga]', '@');
            location.href = "mailto:" + href;
          }
        });

        $(document).on('click','a[href^="mailto:"]', function(e){
          var href = $(this).attr('href');
          if ( href && href.indexOf('[at]') > 0 ) {
            e.preventDefault();
            href = href.replace('[dot]', '.');
            href = href.replace('[at]', '@');
            location.href = href;
          }
        });

        if ( $('body').hasClass('page-template-tpl-memners-area-technologies') || $('body').hasClass('page-template-tpl-public-technologies') ) {
          var qs_regex;
          var button_filter = '';
          var region_filter = [];
          var services_filter = [];
          var technology_filter = [];

          $('.filter-box .ft-checkbox').each(function(){
            if ( $(this).attr('data-parent') !== '0' ) {
              $(this).addClass('ft-checkbox-h');
              $(this).insertBefore($(this).closest('.filter-box').find('.ft-checkbox[data-id="' + $(this).attr('data-parent') + '"]'));
            }
          });

          $('.filter-box .ft-checkbox').each(function(){
            if ( $(this).attr('data-parent') === '0' ) {
              $(this).insertBefore($(this).closest('.filter-box').find('.ft-checkbox[data-parent="' + $(this).attr('data-id') + '"]').first());
            }
          });

          $('.cgf-food-tech-listing-main .cgf-tech-box-wrapper .cgf-tech-box').matchHeight({byRow: false});
          // init Isotope
          var $grid = $('.cgf-food-tech-listing-main .cgf-tech-box-wrapper').isotope({
            itemSelector: '.cgf-tech-box',
            layoutMode: 'fitRows',
            filter: function() {
              var $this = $(this);
              var search_result   = qs_regex ? $this.text().match( qs_regex ) : true;
              var region_results  = false;
              var button_result   = true;
              if ( region_filter.length > 0 ) {
                for (var j = 0; j < region_filter.length; j++) {
                  if ( region_filter[j] !== '*' && ! region_results ) {
                    button_result   = $this.is( button_filter + region_filter[j] );
                    region_results  = button_result ? true : false;
                  }
                }
              } else {
                button_result = button_filter ? $this.is( button_filter ) : true;
              }

              return search_result && button_result;
            }
          });

          $grid.on(
            'arrangeComplete',
            function( event, filteredItems ) {
              if( filteredItems.length > 0 ) {
                $grid.closest('.cgf-food-tech-listing-main').find('.cgf-no-results').hide();
              } else {
                $grid.closest('.cgf-food-tech-listing-main').find('.cgf-no-results').show();
              }
            });

          function cgf_partner_update_filters() {

            var search_terms = [];
            region_filter = [];

            $('.cgf-food-tech-filters .filter-box input:checked').each(function() {
              var select_value = $(this).attr('data-filter');
              if ( $(this).closest('.filter-box').is('.fb-country') ) {
                region_filter.push( select_value );
              } else {
                if ( select_value !== '*' ) {
                  search_terms.push( select_value );
                }
              }
            });
            if ( search_terms.length < 1 ) {
              search_terms.push('*')
            }

            button_filter = '';
            for (var k = 0; k < search_terms.length; k++) {
              button_filter += search_terms[k];
            }
            $grid.isotope();

          }

          $('.cgf-food-tech-filters .filter-box input').on( 'change', function(e) {
            cgf_partner_update_filters();
          });

          cgf_partner_update_filters();

          // use value of search field to filter
          var $quicksearch = $('#cgf-tech-quicksearch').keyup( debounce( function() {
            qs_regex = new RegExp( $quicksearch.val(), 'gi' );
            $grid.isotope();
          }) );

          // debounce so filtering doesn't happen every millisecond
          function debounce( fn, threshold ) {
            var timeout;
            threshold = threshold || 100;
            return function debounced() {
              clearTimeout( timeout );
              var args = arguments;
              var _this = this;
              function delayed() {
                fn.apply( _this, args );
              }
              timeout = setTimeout( delayed, threshold );
            };
          }


          function ft_update_status(label, result) {
            if(!result.length) {
              label.html(label.attr('data-label'));
            } else {
              label.html(label.attr('data-label') + ' [ ' + result.length +' ]');
            }
          };

          function ft_checkbox_dropdown(el) {
            var $el = $(el)

            $el.each(function(i, element) {
              var $list = $(this).find('.ft-dropdown-list'),
                $label = $(this).find('.ft-dropdown-label'),
                $checkAll = $(this).find('.check-all'),
                $inputs = $(this).find('.check'),
                defaultChecked = $(this).find('input[type=checkbox]:checked'),
                result = [],
                _elem = $(this);

              ft_update_status($label, result);

              $label.on('click', function() {
                _elem.toggleClass('open');
              });

              $checkAll.on('change', function() {
                var checked = $(this).is(':checked');
                var checkedText = $(this).next().text();
                result = [];
                if(checked) {
                  result.push(checkedText);
                  $label.html(result);
                  $inputs.prop('checked', false);
                }else{
                  $label.html(result);
                }
                ft_update_status($label, result);
              });

              $inputs.on('change', function() {
                var checked = $(this).is(':checked');
                var checkedText = $(this).next().text();
                if($checkAll.is(':checked')) {
                  result = [];
                }
                if(checked) {
                  result.push(checkedText);
                  $label.html(result.join(", "));
                  $checkAll.prop('checked', false);
                }else{
                  var index = result.indexOf(checkedText);
                  if (index >= 0) {
                    result.splice(index, 1);
                  }
                  $label.html(result.join(", "));
                }
                ft_update_status($label, result);
              });

              $(document).on('click touchstart', '.ft-dropdown-overlay', function(e) {
                $(this).closest('.ft-dropdown').removeClass('open');
              });
            });
          };

          ft_checkbox_dropdown('.ft-dropdown');
        }

        var decodeEntities = (function() {
        // this prevents any overhead from creating the object each time
        var element = document.createElement('div');

        function decodeHTMLEntities (str) {
          if(str && typeof str === 'string') {
            // strip script/html tags
            str = str.replace(/<script[^>]*>([\S\s]*?)<\/script>/gmi, '');
            str = str.replace(/<\/?\w(?:[^"'>]|"[^"]*"|'[^']*')*>/gmi, '');
            element.innerHTML = str;
            str = element.textContent;
            element.textContent = '';
          }

          return str;
        }

        return decodeHTMLEntities;
      })();


        var query_s_params  = new URLSearchParams(window.location.search);
        var query_params    = Object.fromEntries(query_s_params.entries());
        if( typeof query_params.topic !== 'undefined' ) {
          if ( $('#mc_embed_signup').length > 0 ) {
            var topics = decodeEntities ( query_params.topic ).split(",");
            for (var i = topics.length - 1; i >= 0; i--) {
              $(document).find('.mc-field-group.input-group').each(function(){
                $(this).find('li > label').each(function(){
                  console.warn(topics[i].toLowerCase());
                  console.warn($(this).text().replace(/\s+/g, " ").toLowerCase());
                  if ( $(this).text().toLowerCase().includes( topics[i].toLowerCase() ) ) {
                    $(this).trigger('click');
                  }
                });
              });
            }
          }
        }

        $('.cgf-single-post-layout .sidebar').stick_in_parent({ offset_top: 140 });

        $(document).find('.cgf-single-post-layout .post-main-content-area img').each(function() {
          var image = $(this);
          if ( image.closest('table').length <= 0 ) {
            if ( image.hasClass('alignright') || image.hasClass('alignleft') || image.hasClass('img_left') || image.hasClass('img_right') ) {
              // if ( image.hasClass('alignright') || image.hasClass('img_right') ) {
              //   image.addClass('cgf-content-image-sm').addClass('ci-right');
              // }
              // if ( image.hasClass('alignleft') || image.hasClass('img_left') ) {
              //   image.addClass('cgf-content-image-sm').addClass('ci-left');
              // }
            } else {
              if ( image.width() < $(this).closest('.post-main-content-area').find('> .content-sizer').innerWidth() ) {
                image.wrap('<span class="cgf-content-image-off ci-padded"></span>');
              } else {
                image.wrap('<span class="cgf-content-image-off ci-full-width"></span>');
              }
            }
          }
        });

        $(document).find('.cgf-content-image-off').each(function(){
          var parent = $(this).parent();
          var item_count = parent.find('.cgf-content-image-off').length;
          if ( item_count > 1 ) {
            parent.attr( 'data-count', item_count ).addClass('cgf-content-gallery');
          }
        });

        $('.cgf-single-post-layout .post-main-content-area iframe[src*="youtube"]').wrap("<div class='gfsi-vid-cont'></div>");
        $('.cgf-single-post-layout .post-main-content-area iframe[src*="vimeo"]').wrap("<div class='gfsi-vid-cont'></div>");


        $(window).on('load resize', function () {
          adjust_iframes();
        });

        /* ******* HIDE ******** */
        $('.generic-popup .generic-overlay, .generic-popup .generic-popup-close').on('click', function (e) {
          e.preventDefault();
          $('.generic-popup').fadeOut();
          $('.generic-popup').find('iframe').attr('src', '');
        });

        $('.play-youtube-popup').on('click', function (e) {
          e.preventDefault();

          var youtubeId = $(this).data('youtube');
          var url = 'https://www.youtube.com/embed/' + youtubeId;

          $('.generic-popup').find('iframe').attr('src', url);
          $('.generic-popup').fadeIn();

          adjust_iframes();
        });


        // JavaScript to be fired on all pages
        var y = $(window).scrollTop();
        var mhu = false;
        $(window).load(function () {
          $(window).scrollTop(y + 150);
          $(window).scrollTop(y - 150);
        });

        var scriptadded = false;

        function isScrolledIntoView(elem) {
          var docViewTop = $(window).scrollTop();
          var docViewBottom = docViewTop + $(window).height();

          var elemTop = $(elem).offset().top;
          var elemBottom = elemTop + $(elem).height();

          return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop));
        }

        function loadExecuteTwitter() {
          var twttrWidget = $(document).find('[data-twitter]');
          if (twttrWidget.length > 0 && !scriptadded) {
            if (isScrolledIntoView(twttrWidget)) {
              var elem = document.createElement('script');
              var insertElem = document.getElementsByTagName('script')[0];

              elem.src = ' https://platform.twitter.com/widgets.js';

              scriptadded = true;
              $('.tweet-feed-cont').append(elem);

            }
          }
        }

        $(window).scroll(function () {
          loadExecuteTwitter();
        });

        loadExecuteTwitter();


        $('.featured-news .post-block .featured-news-info').matchHeight({byRow: true});
        $('#page-wrap .gallery .gallery-caption').matchHeight({byRow: false});

        $(window).scroll(function () {
          if ($(window).scrollTop() >= 150) {
            $('.cgf-new-site-header').addClass('slideDown');
            $('.select-lang').removeClass('init-visible');
            $('.members-area-menu__dropdown').removeClass('open-dropdown-members');
          } else {
            $('.cgf-new-site-header').removeClass('slideDown');
            $('.sub-menu').removeClass('menu-show');
            $('.wrap-page').removeClass('fixed');
            $('.top-link').removeClass('active-link');
            $('.sub-menu-wrap').removeClass('menu-show');
          }


        });

        if ($('.cgf-init-menu-sticky').length > 0) {
          $('.cgf-init-menu-sticky .sticky-menu-wrap').affix({
            offset: {
              top: $('.cgf-init-menu-sticky').offset().top - 100
            }
          });
        }


        $(document).find('.cgf-timeline-slider').each(function () {
          $(this).find('.horizontal-timeline').horizontalTimeline({
            dateDisplay: "date",
            autoplay: true,
            autoplaySpeed: 8,  // Sec
            autoplayPause_onHover: true,
            useTouchSwipe: true,
            date: 'DD MM YYYY',
            iconClass: {
              "base": "", // Space separated class names
              "scrollLeft": "cgf-hidden",
              "scrollRight": "cgf-hidden",
              "prev": "cgf-timeline-chevron-left",
              "next": "cgf-timeline-chevron-right",
              "pause": "cgf-hidden",
              "play": "cgf-hidden"
            },

          });
        });

        $('.has-children').on('click', function () {
          var elem = $(this);
          $(document).find('.img_placeholder, .img-contain').each(function () {
            var bg_img = $(this).attr('data-bgimg');
            if (bg_img) {
              $(this).css('background-image', 'url(' + bg_img + ')').removeAttr('data-bgimg');
            }
          });
        });

        $(document).on('click', '.cgf-mega-menu-wrap .menu-item-has-child > a', function (e) {
          e.preventDefault();
          var parent = $(this).closest('.menu-item-has-child');
          if (parent.hasClass('menu-item-open')) {
            parent.removeClass('menu-item-open');
            parent.closest('.cgf-mega-menu-wrap').removeClass('mm-menu-open');
            $('body').focus();
          } else {
            $(document).find('.cgf-mega-menu-wrap .menu-item-has-child').removeClass('menu-item-open');
            parent.addClass('menu-item-open');
            parent.closest('.cgf-mega-menu-wrap').addClass('mm-menu-open');
          }
        });

        $(document).on('click', '.menu-layout-two-cols .menu-item-has-submenu.submenu-links > a', function (e) {
          if (!$(this).closest('li').hasClass('sub-menu-open')) {
            e.preventDefault();
          }
          $(this).closest('li').toggleClass('sub-menu-open');
        });

        $(document).on('click', '.mega-menu-container-mobile .menu-layout-equal-cols .menu-item-has-submenu > a', function (e) {
          if (!$(this).closest('li').hasClass('sub-menu-open')) {
            e.preventDefault();
          }
          $(this).closest('li').toggleClass('sub-menu-open');
        });

        $(document).on('click', '.cgf-mega-menu-wrap .mm-menu-overlay', function () {
          $(document).find('.cgf-mega-menu-wrap .menu-item-has-child').removeClass('menu-item-open');
          $('.cgf-mega-menu-wrap').removeClass('mm-menu-open');
          $('body').focus();
        });

        $(document).scroll(function () {
          $(document).find('.cgf-mega-menu-wrap .menu-item-has-child').removeClass('menu-item-open');
          $('.cgf-mega-menu-wrap').removeClass('mm-menu-open');
          $('body').focus();
        });


        // $('.cgf-partner-logos-wrap .owl-carousel').each(function(){
        //   $(this).owlCarousel({
        //     center: false,
        //     items: 1,
        //     loop: true,
        //     nav: false,
        //     dots: false,
        //     margin: 20,
        //     drag: true,
        //     autoplay: true,
        //     smartSpeed: 1500,
        //     autoplayTimeout: 3000,
        //     autoplayHoverPause: true,
        //     responsive: {
        //       767 : {
        //         items: 3,
        //       },
        //       992 : {
        //         items: 5,
        //       },
        //     },
        //   });
        // });

        $(window).load(function(){
          if($('.cgf-partner-logos-wrap').length){
            var items = $('body').find('.all-items').html();
            items = JSON.parse(items);

            var totalSlots = $('body').find('.slot').length;
            var index = 0;
            var indexImage = -1;
            var totalItems = items.length;
            var useSlot = 1;

            var myInterval = setInterval(function () {
              index = index + 1;
              indexImage = indexImage + 1;

              var image = items[indexImage];

              if(indexImage === totalItems){
                indexImage = -1;
              }

              if (totalSlots === 5) {
                if (index === 1) {
                  useSlot = 2;
                }
                if (index === 2) {
                  useSlot = 1;
                }
                if (index === 3) {
                  useSlot = 5;
                }
                if (index === 4) {
                  useSlot = 4;
                }
                if (index === 5) {
                  useSlot = 3;
                }

                // reset index
                if (index === 5) {
                  index = 0;
                }
              }


              if (totalSlots === 2) {
                useSlot = index;

                // reset index
                if (index === 2) {
                  index = 0;
                }
              }

              // start fadeout
              $('body').find('.slot.slot-' + useSlot + ' .current-item').fadeOut(1500);
              $('body').find('.slot.slot-' + useSlot).append('<div class="current-item new" style="background-image: url(' + image + ')"></div>');
              $('body').find('.slot.slot-' + useSlot + ' .current-item.new').fadeIn(1500).removeClass('new');
            }, 3500);
          }
        });

        setTimeout(function () {
          $('.bx-slide-posts').each(function () {
            $(this).bxSlider({
              pager: true,
              controls: false,
              // mode: 'slide',
              // auto: true,
              // pause: 7000,
              // infiniteLoop: false,
              // hideControlOnEnd: true
            });
          });
        }, 500);

        $('.cgf-homepage-slider .cgf-homepage-slider-wrap .slick-carousel').slick({
          dots: false,
          arrows: false,
          fade: true,
          autoplay: true,
          autoplaySpeed: 4500,
        });

        $('.cgf-homepage-slider .cgf-homepage-slider-wrap .slick-carousel').on('afterChange', function (event, slick, currentSlide, nextSlide) {
          console.log(currentSlide);
          var image_container = $(slick.$slider).closest('.cgf-homepage-slider').find('.slider-image-container');
          if (image_container.length > 0 && image_container.find('li[data-index="' + currentSlide + '"]').length > 0) {
            image_container.find('li').removeClass('active');
            image_container.find('li[data-index="' + currentSlide + '"]').addClass('active');
          }
        });

        $(' .owl-carousel').each(function () {
          $(this).owlCarousel({
            center: true,
            items: 1,
            loop: true,
            nav: false,
            dots: false,
            margin: 20,
            drag: true,
            autoplay: true,
            lazyLoad: true,
            autoplayTimeout: 6000,
            autoplayHoverPause: true
          });
        });


        $('.testimonial-slider-flex .owl-carousel').owlCarousel({
          center: false,
          items: 1,
          loop: true,
          nav: false,
          dots: true,
          margin: 40,
          drag: true,
          autoplay: true,
          autoplayTimeout: 10000,
          autoplayHoverPause: true,
          autoHeight: true,
        });

        $(document).on('click', '.sfw-filter-toggle', function (e) {
          e.preventDefault();
          $(this).toggleClass('active');
          $(this).closest('.search-filter-wrap').find('.sfw-filter-row').toggleClass('open');
        });
        var grid = $(document).find('.cgf-masonry-wrap');

        function masonry_facet() {
          if (grid.length > 0) {
            grid.masonry({
              // options
              columnWidth: '.resource-sizer',
              itemSelector: '.resource-card',
              percentPosition: true,
            });
            setTimeout(function () {
              grid.masonry('reloadItems');
              grid.masonry('layout');
              $(window).resize();
            }, 200);

            $('.resource-card img').on('load', function (event) {
              grid.masonry('reloadItems');
              grid.masonry('layout');
              $(window).resize();
            });
          }
          var last_item = grid.find('.resource-card').last();
          $('.res_sort_rel_f').attr('href', last_item.attr('data-sort_rel'));
          $('.res_sort_date_f').attr('href', last_item.attr('data-sort_date'));
        }

        masonry_facet();

        $(document).on('click', '.cgf-accordian_resources .panel-head-toggle', function(e){
          e.preventDefault();
          var accordian = $(this).closest('.accordion');
          var parent = $(this).closest('.panel-box');
          if ( parent.is('.open') ) {
            parent.removeClass('open');
            parent.find('.panel-body').slideUp(300);
            parent.find('.plus-minus').removeClass('toggled');
          } else {
            parent.addClass('open');
            parent.find('.panel-body').slideDown(300);
            parent.find('.plus-minus').addClass('toggled');
          }
          masonry_facet();
        });

        $(document).on('facetwp-loaded', function () {

          masonry_facet();
          $('.resources-svg-loader').hide();
          $('.resource-masonry-grid').removeClass('loading');

          var is_empty = true;
          var obj = FWP.facets;

          if (FWP.facets.keyword.length > 0) {
            $('.res-sort-filters').show();
          } else {
            $('.res-sort-filters').hide();
          }

          for (var prop in obj) {
            if (obj[prop].length > 0) {
              is_empty = false;
            }
          }

          if (is_empty) {
            // No filters selected
            $('.gradient-resource-wrap .resources-latest').slideDown('300');
          } else {
            // Filters selected
            $('.gradient-resource-wrap .resources-latest').slideUp('300');
          }

        });

        // Facet WP - Load More
        $(document).on('facetwp-refresh', function () {
          if (FWP.loaded) {
            $('.resource-masonry-grid').addClass('loading');
            $('.resources-svg-loader').show();
          }
        });

      },
      finalize: function () {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'home': {
      init: function () {
        // JavaScript to be fired on the home page
      },
      finalize: function () {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function () {
        // JavaScript to be fired on the about us page
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function (func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function () {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function (i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
